import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(
  {
    container: {
      width: "950px",
      height: "600px",
      position: "relative"
    },
    content: {
      width: "100%",
      display: "inline-flex",
      flexWrap: "wrap"
    },
    item: {
      padding: "10px",
      textAlign: "center",
      fontSize: "12px",
      cursor: "pointer",
      "& :hover": {
        color: "#007aff"
      },
      "& svg": {
        fontSize: "65px",
        color: "#fc9300"
      }
    },
    loading: {
      textAlign: "center",
      paddingTop: "30%"
    },
    top: {
      height: "60px",
      backgroundColor: "#ddd"
    },
    f12: {
      lineHeight: "100%",
      height: "20px",
      fontSize: "12px"
    },

    d12: {
      fontSize: "12px"
    },
    topright: {
      position: "fixed",
      right: "5px",
      top: "10%",
      zIndex: 99999,
      border: "5px solid #fff",
      width: "20%",
      background: "#fff"
    },
    media: { width: "100%" },
    path: {
      padding: "5px",
      textDecoration: "underline",
      cursor: "pointer",
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: "#007aff",
        color: "#fff"
      }
    },
    path2: {
      fontSize: "16px",
      color: "#888"
    },
    path3: {
      padding: "5px",
      color: "#888",
      fontWeight: "bold"
    },
    closed: {
      fontSize: "22px",
      fontWeight: "bold",
      position: "absolute",
      right: "10px",
      top: "5px",
      cursor: "pointer",
      color: "#888",
      "&:hover": {
        color: "#000"
      }
    },
    topbtn: {
      margin: "5px 10px",
      height: "28px"
    },
    submit: {
      background: "#1976d2",
      color: "#fff",
      border: "1px solid #1976d2",

      float: "right",
      marginLeft: "10px",
      padding: "4px 10px",

      cursor: "pointer",
      "&:hover": {
        background: "#007aff",
        border: "1px solid #007aff"
      }
    },
    cancel: {
      background: "#eee",
      float: "right",
      marginLeft: "10px",
      padding: "4px 10px",
      border: "1px solid #ddd",
      cursor: "pointer",
      "&:hover": {
        background: "#ddd"
      }
    },

    dtitle: {
      padding: "5px 10px"
    },
    dcontent: {
      padding: "5px"
    }
  },
  { name: "s3" }
);
